import { ApiBase } from '@/api/methods/ApiBase'
import { ApiResponseChartCurriculumUnits } from '@/api/responses/proofread/systemCharts'

export namespace SystemChartsApi {
  /**
   * 知識マップ単元一覧取得API
   *
   * @param chartId 知識マップ系統図ID
   * @returns 単元情報
   */
  export async function getCurriculumUnits(chartId: number): Promise<ApiResponseChartCurriculumUnits> {
    return await ApiBase.get(`/proofread/systemCharts/${chartId}/curriculumUnits`)
  }
}
